import React, { ComponentProps, RefAttributes } from 'react'
import styled from 'styled-components'
import _ListItem from './_ListItem'

const Container = styled(_ListItem)`
  &:disabled {
    color: ${props => props.theme.palette.neutral.default.four};
  }
`

type InheritedBaseListItemProps = Omit<ComponentProps<typeof _ListItem>, 'ref'>
interface Props extends InheritedBaseListItemProps, RefAttributes<HTMLDivElement> {
}

/**
 * For the clickable version use `<ClickableListItem>`.
 */
function ListItem({
  as,
  ...rest
}: Props) {
  return <Container
    {...rest}
    forwardedAs={as}
  />
}

export default ListItem
